import React from "react"
import HistoryList from './History_ListItem'
import { REDEEMPAGE_STRINGS } from '../Strings';



class History_Redeem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      State: "",
      countries: []
    };
  }

  componentDidMount() {
    this.setState({
      State: "ALL",
      countries: [
        { id: '1', name: 'ALL' },
        { id: '2', name: 'Successfull' },
        { id: '3', name: 'Pending' },
        { id: '4', name: 'Rejected' },
        { id: '5', name: 'Cancelled' }
      ]
    });

  }

  onChange = e => {
    if (e.target.name != null) {
      this.setState({ [e.target.name]: e.target.value });
      console.log("State Value:" + this.State);
    }
  };


  render() {

    const { countries } = this.state;
    const accordionData = [
      {
        title: "30-May-2020 - Amount:3000",
        RedeemDetails: [
          { title: "Redeem Option", Status: 'Andra Bank' },
          { title: "A/C Details", Status: "*********2017" },
          { title: "Request Id", Status: "100000" },
          { title: "Processor", Status: "Online Transfer" },
          { title: "Status ", Status: "Processing" },
        ]
      },
      {
        title: "27-May-2020 - Amount:3000",
        RedeemDetails: [
          { title: "Redeem Option", Status: 'Andra Bank' },
          { title: "A/C Details", Status: "*********2017" },
          { title: "Request Id", Status: "100000" },
          { title: "Processor", Status: "Online Transfer" },
          { title: "Status ", Status: "Processing" },
        ]
      },
      {
        title: "28-May-2020 - Amount:5000",
        RedeemDetails: [
          { title: "Redeem Option", Status: 'Andra Bank' },
          { title: "A/C Details", Status: "*********2017" },
          { title: "Request Id", Status: "100000" },
          { title: "Processor", Status: "Online Transfer" },
          { title: "Status ", Status: "Processing" },
        ]
      },
      {
        title: "28-May-2020 - Amount:5000",
        RedeemDetails: [
          { title: "Redeem Option", Status: 'Andra Bank' },
          { title: "A/C Details", Status: "*********2017" },
          { title: "Request Id", Status: "100000" },
          { title: "Processor", Status: "Online Transfer" },
          { title: "Status ", Status: "Processing" },
        ]
      },
      {
        title: "28-May-2020 - Amount:5000",
        RedeemDetails: [
          { title: "Redeem Option", Status: 'Andra Bank' },
          { title: "A/C Details", Status: "*********2017" },
          { title: "Request Id", Status: "100000" },
          { title: "Processor", Status: "Online Transfer" },
          { title: "Status ", Status: "Processing" },
        ]
      },
      {
        title: "28-May-2020 - Amount:5000",
        RedeemDetails: [
          { title: "Redeem Option", Status: 'Andra Bank' },
          { title: "A/C Details", Status: "*********2017" },
          { title: "Request Id", Status: "100000" },
          { title: "Processor", Status: "Online Transfer" },
          { title: "Status ", Status: "Processing" },
        ]
      },
      {
        title: "28-May-2020 - Amount:5000",
        RedeemDetails: [
          { title: "Redeem Option", Status: 'Andra Bank' },
          { title: "A/C Details", Status: "*********2017" },
          { title: "Request Id", Status: "100000" },
          { title: "Processor", Status: "Online Transfer" },
          { title: "Status ", Status: "Processing" },
        ]
      },
    ];

    //let countriesList = countries.length > 0 && countries.map((item, i) => {
    // return(<option className="w-100 w-50-l center   bg-green pa3"key={i} value={item.id} style={{color:'#fffdea' }}>{item.name} </option>)
    // }, this);

    return (
      <div className="w-100 center pt4 pa2-l" style={{ minHeight: '100vh' }}>

        <select value={this.State} name="State" id="State" onChange={this.onChange} className="w-40 pa2  mr3  mr5-l ba br1 pointer dib fr " style={{ backgroundColor: '#00214a', color: '#fffdea', display: 'block' }}  >
          <p className="dark-gray ma0  pa2 flex justify-between items-center br2">
            <span className="pr1" style={{ color: '#fffdea' }}>ALL</span>
            <img className="w1 h1" alt="" >
            </img ></p>
          {countries.map((item, i) => <option style={{ backgroundColor: '#00214a', color: '#fffdea' }} key={i} value={item.name}>{item.name}</option>)}
        </select>

        <div className="w-100  pa4-l center mt5 ">
          {accordionData.map(({ title, RedeemDetails }) => (
            <HistoryList title={title} RedeemDetails={RedeemDetails} />
          ))}
          <div className="w-100 tc center mt3  ba br2 b--solid b--black-90 ">
            <p className="f4-l f7-m f8-ns" style={{ color: '#bad1d7' }}>{REDEEMPAGE_STRINGS.KEY_FOR_ANY_QURIES} <a className="light-blue underline" href="0">{REDEEMPAGE_STRINGS.KEY_REDEEM_INFO_MAIL} </a> {REDEEMPAGE_STRINGS.KEY_OR_CALL} <a className="light-blue underline" href="0">{REDEEMPAGE_STRINGS.KEY_REDEEM_INFO_MOBILE}</a>{REDEEMPAGE_STRINGS.KEY_CALL_CHARGES}</p></div>
        </div>


      </div>



    );
  }
}
export default History_Redeem;